<template>
  <van-popup v-model="show_play_view" position="bottom" :style="{ height: '100%' }">
    <div id="video_container" class="popup_div">
      <div class="close" @click="closePlay">
        <img src="@/assets/close_black.png" alt="">
      </div>
    </div>
  </van-popup>
</template>
<script src="https://p.bokecc.com/player?siteid=2661F9756E5C832E&newversion=true"></script>

<script>
import cookies from 'js-cookie'
import { statistic } from "@/api/exam.js";
import AES from '@/utils/aes.js'

export default {
  props: ['show_play_view', 'awk_id'],
  data() {
    return {
      show: true,
      lesson_id: '',
      isBuy: false,
      invervalRecord: null,
      username: cookies.get("username") ? cookies.get("username") : '',
      terminal: 0,
      playTime: 0,
      allTime: 0,
      player: '',
      video_container: ''
    }
  },
  watch: {
    show_play_view(newV) {
      this.showPop = newV
      if (newV) {
        this.showPlayer()
      }
      else {
        this.closePlayerTimer()
      }
    }
  },
  created() {
  },
  methods: {
    // 关闭播放器
    closePlay() {
      this.closePlayerTimer()
      this.$emit('closePlay')
    },
    // 开始开启播放
    showPlayer() {
      this.setPlayerCallBack()
      this.showPlayerTimer()
    },
    // 设置播放回调方法
    setPlayerCallBack() {
      window.on_CCH5player_ready = this.onPlayerReady;
      window.on_CCH5player_ended = this.on_CCH5player_ended;
      window.on_player_timeupdate = this.on_player_timeupdate;
      window.get_cc_verification_code = this.get_cc_verification_code;
      window.on_h5player_error = this.on_CCH5player_error;
    },
    // 准备好播放
    onPlayerReady() {
      // 初始化完成之后的回调
      this.playTime = window.cc_js_Player.getPosition();
    },
    on_player_timeupdate(currentTime, vid) {
      // 总时长
      const allTime = window.cc_js_Player.getDuration()
      if (allTime > 0) {
        this.allTime = allTime
      }
      if (currentTime <= this.playTime || currentTime == allTime) {
        // 刚开始或播放完毕
        this.playTime = currentTime
        this.recordTime()
      }
      else {
        const limit = 3
        if (currentTime - this.playTime >= limit) {
          this.playTime = currentTime;
          this.recordTime()
        }
      }
    },
    onCCH5PlayerLoaded() {
      // 播放器js文件加载完成时回调
      window.ccH5PlayerJsLoaded = true;
    },
    // 授权验证
    get_cc_verification_code(vid) {
      const auth = "videoid=CC784E8C14B93C2CFC9558351D509E7C&payer_name=3767a1646278314a8583&check_code=80373a0c1a08973b82c5980922c0a145"
      return auth;
    },
    // 播放完毕
    on_CCH5player_ended(video, vid) {
      this.playTime = this.allTime;
      this.recordTime()
    },
    // 播放出错
    on_CCH5player_error(errInfo) {
      console.log('errInfo ', errInfo);
    },
    // 开启定时器
    showPlayerTimer() {
      const u = navigator.userAgent;
      if (u.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i)) {
        this.terminal = 1;
      } else {
        this.terminal = 0;
      }
    },
    // 定时器方法
    intervalTime() {
      //每3秒获取一次时间
      // this.recordTime();
    },
    // 记录播放时间
    recordTime() {
      // //记录播放时间
      // const info = {
      //   lesson_id: this.lesson_id,
      //   username: this.username,
      //   wk_id: this.awk_id,
      //   terminal: this.terminal,
      //   watch_time: parseInt(this.playTime),
      // };
      // statistic(info).then((res) => { });
    },
    // 关闭定时器
    closePlayerTimer() {
      clearInterval(this.invervalRecord);
    },
  }
}
</script>
<style lang="scss" scoped>
.test {
  width: 100%;
  height: 200px;
  background-color: aqua;
}
.popup_div {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #fff;
  .close {
    z-index: 300;
    position: absolute;
    left: 20px;
    top: 20px;
    background-color: rgba($color: #fff, $alpha: 0.7);
    width: 70px;
    height: 70px;
    border-radius: 50px;
    img {
      margin: 20px auto;
      width: 30px;
      height: 30px;
      display: block;
    }
  }
}
</style>
